import React from "react";
import foodyAppIcon from "../assets/icons/foody-app-icon.svg";
import foodyMockup from "../assets/mockups/foody-mockup.png";
import appleStoreBadge from "../assets/badges/apple-store-badge.svg";
import googlePlayBadge from "../assets/badges/google-play-badge.svg";
import NavBar from "./NavBar";
import { publishedApps } from "../data/appData";

const FoodyPage = ({ language, onLanguageChange, t }) => {
  const foodyApp =
    publishedApps.find((app) => app.detailPath === "/apps/foody") || {};
  const appStoreUrl = foodyApp.appStoreUrl || "#";
  const googlePlayUrl = foodyApp.googlePlayUrl || "#";
  const highlights = t("foody.highlights.items") || [];
  const steps = t("foody.workflow.steps") || [];
  const personas = t("foody.personas.items") || [];

  return (
    <div className="page foody-page" id="foody-top">
      <NavBar
        language={language}
        onLanguageChange={onLanguageChange}
        items={[
          { href: "/#apps", label: t("foody.meta.back") },
          {
            href: "/apps/foody/static/support",
            label: t("foodySupport.badge"),
            className: "nav-support-outline",
          },
        ]}
      />

      <main className="foody-main">
        <section className="foody-hero">
          <div className="foody-hero-copy">
            <div className="foody-hero-icon">
              <img src={foodyAppIcon} alt="Foody app icon" />
            </div>
            <span className="foody-eyebrow">{t("foody.hero.eyebrow")}</span>

            <h1>{t("foody.hero.title")}</h1>
            <p>{t("foody.hero.subtitle")}</p>
            <div className="store-badges foody-store-badges">
              {foodyApp.appStoreUrl && (
                <a
                  className="store-badge"
                  href={appStoreUrl}
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={appleStoreBadge} alt="App Store" />
                </a>
              )}
              {foodyApp.googlePlayUrl && (
                <a
                  className="store-badge"
                  href={googlePlayUrl}
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={googlePlayBadge} alt="Google Play" />
                </a>
              )}
            </div>
          </div>
          <div className="foody-hero-visual">
            <div className="foody-mockup">
              <img src={foodyMockup} alt="Foody app screens" />
            </div>
          </div>
        </section>

        <section className="foody-section">
          <div className="foody-section-head">
            <h2>{t("foody.highlights.title")}</h2>
            <p>{t("foody.highlights.subtitle")}</p>
          </div>
          <div className="foody-grid">
            {highlights.map((item) => (
              <article className="foody-card" key={item.title}>
                <h3>{item.title}</h3>
                <p>{item.desc}</p>
              </article>
            ))}
          </div>
        </section>

        <section className="foody-section foody-section-alt">
          <div className="foody-section-head">
            <h2>{t("foody.workflow.title")}</h2>
            <p>{t("foody.workflow.subtitle")}</p>
          </div>
          <div className="foody-steps">
            {steps.map((step, index) => (
              <div className="foody-step" key={step.title}>
                <span className="foody-step-index">0{index + 1}</span>
                <div>
                  <h3>{step.title}</h3>
                  <p>{step.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        <section className="foody-section">
          <div className="foody-section-head">
            <h2>{t("foody.personas.title")}</h2>
            <p>{t("foody.personas.subtitle")}</p>
          </div>
          <div className="foody-tags">
            {personas.map((item) => (
              <span className="foody-tag" key={item}>
                {item}
              </span>
            ))}
          </div>
          <p className="foody-note">{t("foody.personas.note")}</p>
        </section>

        <section className="foody-cta">
          <div>
            <h2>{t("foody.cta.title")}</h2>
            <p>{t("foody.cta.desc")}</p>
          </div>
          <div className="store-badges foody-store-badges">
            {foodyApp.appStoreUrl && (
              <a
                className="store-badge"
                href={appStoreUrl}
                target="_blank"
                rel="noreferrer"
              >
                <img src={appleStoreBadge} alt="App Store" />
              </a>
            )}
            {foodyApp.googlePlayUrl && (
              <a
                className="store-badge"
                href={googlePlayUrl}
                target="_blank"
                rel="noreferrer"
              >
                <img src={googlePlayBadge} alt="Google Play" />
              </a>
            )}
          </div>
        </section>
      </main>
    </div>
  );
};

export default FoodyPage;
